export default {"src":"/_next/static/media/icon-login.af8464c0.svg","height":22,"width":20,"blurWidth":0,"blurHeight":0};